import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
  user,
  },
  state: {
    visitedTags: [] // 存储访问过的菜单标签
  },
  mutations: {
    // 添加新标签（去重）
    ADD_VISITED_TAG(state, tag) {
      if (!state.visitedTags.includes(tag)) {
        state.visitedTags.push(tag)
      }
    },
    // 移除标签
    REMOVE_VISITED_TAG(state, tag) {
      const index = state.visitedTags.indexOf(tag)
      if (index > -1) {
        state.visitedTags.splice(index, 1)
      }
    },
    // 新增：重置根状态
    RESET_ROOT_STATE(state) {
      // 重置根状态（只重置需要清除的数据）
      state.visitedTags = []
    }
  },
  actions: {
    addVisitedTag({ commit }, tag) {
      commit('ADD_VISITED_TAG', tag)
    },
    removeVisitedTag({ commit }, tag) {
      commit('REMOVE_VISITED_TAG', tag)
    },
     // 新增：重置整个 store 的 action
    resetStore({ commit }) {
      // 重置根状态
      commit('RESET_ROOT_STATE')
      
      // 重置 user 模块（通过调用现有 mutation）
      commit('user/removeToken', null, { root: true })
      
      // 如果需要重置 user 模块的其他状态，可以添加更多 commit
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js